import React, { useState, useEffect } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { parse, format } from 'date-fns';
import { t } from './../i18n';
import './BookingFrequency.css';
import useApp from '../AppContext';
import { loadListAllObjects } from './CalendarUtils';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import localeMap from '../crud/locales';
import CustomDropdown from '../Components/CustomDropdown';

export default function BookingFrequency(props) {
    const app = useApp();
    const [serverUrl] = useState(app.serverUrl);
    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [currentDate] = useState(new Date());
    const [timeSlots, setTimeSlots] = useState([]);
    const [openDatePicker, setOpenDatePicker] = useState(false);
    const [frequency, setFrequency] = useState(props.initialData?.frequency || 'weekly');
    const [startTime, setStartTime] = useState(
        props.selectTtimeSlot ? format(new Date(props.selectTtimeSlot), 'HH:mm') : '08:00'
    );
    const [duration, setDuration] = useState(props.initialData?.duration || '30');
    const [endOption, setEndOption] = useState(props.initialData?.endOption || 'never');
    const [endAfterOccurrences, setEndAfterOccurrences] = useState(props.initialData?.occurrences || '10');
    const [endByDate, setEndByDate] = useState(
        props.initialData?.endByDate ? new Date(props.initialData.endByDate) : new Date()
    );

    useEffect(() => {
        if (props.initialData) {
            setFrequency(props.initialData.frequency || 'weekly');
            setStartTime(props.initialData.startTime || '08:00');
            setDuration(props.initialData.duration || '30');
            setEndOption(props.initialData.endOption || 'never');
            setEndAfterOccurrences(props.initialData.occurrences || '10');
            setEndByDate(props.initialData.endByDate ? new Date(props.initialData.endByDate) : new Date());
        }
    }, [props.initialData, props.selectTtimeSlot]);

    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                let allobj = await loadListAllObjects(serverUrl, props.userToken)
                setAllColumnsObj(allobj);
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);

    useEffect(() => {
        async function getWarehouse() {
            if (!props.warehouseid) return;
            if (!props.data) return;
            if (!props.data["Yms_Warehouses"]) return;
            let dstart = 0;
            let dend = 24;
            const wrh = await props.data["Yms_Warehouses"].find(r => Number(r.WarehouseId) === Number(props.warehouseid));
            if (wrh) {
                if (wrh.StartTime) dstart = parse(wrh.StartTime, 'HH:mm', new Date()).getHours();
                if (wrh.EndTime) dend = parse(wrh.EndTime, 'HH:mm', new Date()).getHours() + 1;
            }
            let timSlots = [];
            let min = 0;

            let timeSlotDay = new Date(currentDate);
            timeSlotDay.setHours(0, 0, 0, 0);
            for (let hour = dstart; hour < dend; hour++) {
                let time = new Date(timeSlotDay);
                time.setHours(hour, min, 0, 0);
                timSlots.push(time);
            }
            setTimeSlots(timSlots);
        } getWarehouse();

    }, [props.warehouseid, props.data, currentDate])
    return (
        <>
            <div className="wrapper-booking-frequency">
                <div className='container-prebooking'>
                    <div className='separate-section'>
                        <h6 className="mb-3">{t('bookingFrequency.recurrencePattern', props.language)}</h6>
                    </div>
                    <div>
                        {['weekly', 'monthly'].map(type => (
                            <Form.Check
                                key={type}
                                type="radio"
                                className="mb-2 radio-label-large"
                                label={t(`bookingFrequency.${type}`, props.language)}
                                name="frequencyType"
                                id={`freq-${type}`}
                                checked={frequency === type}
                                onChange={() => setFrequency(type)}
                            />
                        ))}
                    </div>
                </div>
                <div className='container-prebooking'>
                    <div className='separate-section'>
                        <h6 className="mb-3">{t('bookingFrequency.bookingTimeTitle', props.language)}</h6>
                    </div>

                    <Col>
                        <Row className="mb-3 align-items-center w-50">
                            <Col xs="auto">
                                <Form.Label className="mb-0">
                                    {t('bookingFrequency.startTime', props.language)}
                                </Form.Label>
                            </Col>
                            <Col className='mx-2'>
                                <CustomDropdown
                                    options={timeSlots.map((slot) => {
                                        const timeStr = format(slot, 'HH:mm');
                                        const displayText = `${format(slot, 'H:mm')} ${Number(format(slot, 'H')) < 12 ? t('bookingFrequency.am', props.language) : t('bookingFrequency.pm', props.language)}`;
                                        return {
                                            value: timeStr,
                                            label: displayText
                                        };
                                    })}
                                    value={startTime}
                                    onChange={(e) => setStartTime(e.target.value)}
                                    className="custom-select-Frequency"
                                    showEmptyOption={false}
                                />
                            </Col>
                        </Row>
                        {!props.disableDuration && (
                            <Row className="mb-3 align-items-center" style={{ width: '49%' }}>
                                <Col xs="auto">
                                    <Form.Label className="mb-0">
                                        {t('bookingFrequency.duration', props.language)}
                                    </Form.Label>
                                </Col>

                                <Col>
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        defaultValue={30}
                                        step="1"
                                        value={duration}
                                        onChange={(e) => setDuration(e.target.value)}
                                        disabled={props.disableDuration}
                                    />

                                </Col>
                                <Col>
                                    <span>λεπτά</span>
                                </Col>
                            </Row>
                        )}


                    </Col>

                </div>
                <div className='container-prebooking'>
                    <div className='separate-section'>
                        <h6 className="mb-3">{t('bookingFrequency.recurrencePeriod', props.language)}</h6>
                    </div>

                    <Row className="align-items-start mb-3">
                        <Col className='w-50'>
                            <Form.Check
                                className="mb-2 radio-label-large"
                                type="radio"
                                id="never"
                                label={t('bookingFrequency.never', props.language)}
                                name="endOption"
                                checked={endOption === 'never'}
                                onChange={() => setEndOption('never')}
                            />
                            <Form.Check
                                className="mb-2 radio-label-large"
                                type="radio"
                                id="after"
                                label={
                                    <>
                                        {t('bookingFrequency.endAfter', props.language)}
                                        <Form.Control
                                            type="number"
                                            value={endAfterOccurrences}
                                            onChange={(e) => setEndAfterOccurrences(e.target.value)}
                                            style={{ display: 'inline', width: '80px', margin: '0 4px', padding: '4px 10px' }}
                                        />
                                        {t('bookingFrequency.times', props.language)}
                                    </>
                                }
                                name="endOption"
                                checked={endOption === 'after'}
                                onChange={() => setEndOption('after')}
                            />
                            <Form.Check
                                className="mb-2 radio-label-large"
                                type="radio"
                                id="until"
                                label={
                                    <>
                                        {t('bookingFrequency.endBy', props.language)}
                                        <Form.Control
                                            type="text"
                                            value={format(new Date(endByDate), 'dd/MM/yyyy')}
                                            onClick={() => setOpenDatePicker((prev) => !prev)}
                                            readOnly
                                            style={{ display: 'inline', width: '110px', margin: '0 4px', padding: '4px 10px', cursor: 'pointer' }}
                                        />
                                        {openDatePicker && (
                                            <div style={{
                                                position: 'absolute',
                                                bottom: '28%',
                                                left: "6%",
                                                zIndex: 10,
                                            }}>
                                                <DatePicker
                                                    selected={new Date(endByDate)}
                                                    onChange={(date) => {
                                                        setEndByDate(format(date, 'yyyy-MM-dd'));
                                                        setOpenDatePicker(false);
                                                    }}
                                                    onClickOutside={() => setOpenDatePicker(false)}
                                                    inline
                                                    locale={localeMap[props.language] || localeMap['el']}
                                                />
                                            </div>
                                        )}
                                    </>
                                }
                                name="endOption"
                                checked={endOption === 'until'}
                                onChange={() => setEndOption('until')}
                            />
                        </Col>
                    </Row>
                </div>
            </div >
            <div className="button-save-pos">
                <button
                    onClick={() => {
                        let endOptionData = {};

                        if (endOption === 'never') {
                            endOptionData = { endOption: 'never' };
                        } else if (endOption === 'after') {
                            endOptionData = {
                                endOption: 'after',
                                occurrences: endAfterOccurrences,
                            };
                        } else if (endOption === 'until') {
                            endOptionData = {
                                endOption: 'until',
                                endByDate: format(new Date(endByDate), 'yyyy-MM-dd'),
                            };
                        }

                        const data = {
                            frequency,
                            duration,
                            startTime,
                            ...endOptionData,
                        };
                        if (props.onSelectBookingFrequency) {
                            props.onSelectBookingFrequency(data);
                        }
                        if (props.onClose) {
                            props.onClose();
                        }
                    }}
                >
                    <i className="bi bi-save me-1"></i> {t('common.select', props.language)}
                </button>
            </div >

        </>
    );
}
